// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__1nSu1","resizable__container":"Carousel_resizable__container__riZHX"};